<template>
  <div :class="$style.poptip">
    <FadeTransition>
      <DolphinBalloon v-show="isBalloonShown" :class="$style.poptip__balloon">
        <slot />
      </DolphinBalloon>
    </FadeTransition>
    <IconQuestion
      @mouseenter="isBalloonShown = true"
      @mouseleave="isBalloonShown = false"
      :class="$style.poptip__icon"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconQuestion from '@/components/icons/IconQuestion.vue'
import DolphinBalloon from '@/components/atoms/DolphinBalloon.vue'
import FadeTransition from '@/components/transitions/FadeTransition.vue'

type Data = {
  isBalloonShown: boolean
}

export default defineComponent({
  name: 'HelpPoptip',
  components: {
    DolphinBalloon,
    FadeTransition,
    IconQuestion,
  },
  data(): Data {
    return { isBalloonShown: false }
  },
})
</script>

<style lang="scss" module>
.fade {
  // stylelint-disable selector-class-pattern
  &--enter-active,
  &--leave-active {
    transition: opacity $transition-interaction;
  }

  &--enter-from,
  &--leave-to {
    opacity: 0;
  }
  // stylelint-enable selector-class-pattern
}

.poptip {
  $icon-size: 20px;

  position: relative;
  width: $icon-size;
  height: $icon-size;

  &:hover {
    cursor: pointer;
  }

  &__balloon {
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin: 0 0 24px;
    color: $color-text-and-object-high-emphasis-inverse;
    font-size: 12px;
    transform: translateX(-50%);
  }

  &__icon {
    width: $icon-size;
    height: $icon-size;
    color: $color-text-and-object-accent-primary;
    vertical-align: unset;
  }
}
</style>
